var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _g2, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServiceendpointlarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.86 69.46L19.79 42.57C18.62 42.03 16.66 41 13.54 42.57C11.75 43.47 12.82 45.32 13.54 45.71L62.95 74.56C63.99 75.08 66.55 75.66 68.42 73.77C70.3 71.89 68.16 70.11 66.86 69.45V69.46Z",
    fill: "url(#paint0_linear_3890_386542)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.17 54.62C69.17 50.54 66.31 45.61 62.79 43.58C62.12 43.19 61.38 42.91 60.6 42.77C59.75 38.23 56.91 33.43 53.36 30.53C53.34 30.51 53.31 30.48 53.29 30.46C53.17 30.37 53.06 30.28 52.94 30.18L52.8 30.09L52.48 29.86L52.34 29.77L52.02 29.56L51.88 29.47C51.72 29.38 51.58 29.29 51.42 29.19C51.26 29.1 51.12 29.01 50.96 28.94L50.91 28.92C50.77 28.85 50.63 28.78 50.5 28.71L50.41 28.66C49.56 28.25 48.64 28.01 47.67 27.92C47.14 22.18 43.54 15.75 38.93 12.18C38.79 12.06 38.63 11.95 38.49 11.86C38.35 11.77 38.19 11.65 38.05 11.56L37.93 11.49C37.81 11.42 37.7 11.33 37.58 11.26C37.42 11.17 37.26 11.05 37.1 10.96C36.94 10.87 36.78 10.78 36.64 10.71L36.5 10.64C36.41 10.59 36.32 10.55 36.2 10.5L36.08 10.43L35.96 10.38C35.87 10.33 35.8 10.31 35.71 10.26L35.57 10.19C35.5 10.17 35.43 10.14 35.36 10.12L35.27 10.07L35.06 9.97999L34.83 9.90999L34.58 9.83999L34.35 9.78999C34.26 9.76999 34.19 9.73999 34.1 9.71999L33.87 9.66999L33.62 9.59999L33.41 9.54999L33.18 9.52999C33.11 9.52999 33.04 9.50999 32.97 9.50999L32.74 9.48999H32.07C32 9.48999 31.91 9.48999 31.84 9.50999L31.66 9.52999C31.59 9.52999 31.5 9.54999 31.43 9.54999L31.25 9.56999C31.18 9.58999 31.09 9.58999 31.02 9.61999L30.86 9.66999C30.79 9.68999 30.7 9.71999 30.63 9.73999C30.56 9.75999 30.54 9.75999 30.47 9.78999C30.38 9.80999 30.31 9.85999 30.22 9.87999C30.17 9.89999 30.13 9.89999 30.1 9.92999C29.98 9.97999 29.87 10.05 29.75 10.09L29.66 10.14L29.52 10.23L23.57 13.76L25.55 15.33C25.46 15.38 25.37 15.42 25.25 15.47H25.23L15.16 21.26L19.08 23.06L22.7 21.95C23.09 27.16 26.73 33.18 31.16 35.73L60.13 56.41L61.03 62.43L67.3 58.74H67.32L67.37 58.72C68.45 58.03 69.17 56.62 69.17 54.62Z",
    fill: "url(#paint1_linear_3890_386542)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.54 47.24C55.87 46.85 55.13 46.57 54.35 46.43C53.34 41.08 49.62 35.41 45.2 32.85C43.86 32.09 42.6 31.67 41.44 31.58C40.84 25.1 36.35 17.75 30.88 14.59C25 11.2 20.23 13.94 20.23 20.74C20.23 20.97 20.23 21.2 20.25 21.43C15.96 19.45 12.6 21.68 12.6 26.78C12.6 32.2 16.4 38.79 21.11 41.49L56.56 61.96C60.09 63.99 62.94 62.35 62.94 58.27C62.94 54.19 60.06 49.26 56.53 47.23L56.54 47.24Z",
    fill: "url(#paint2_linear_3890_386542)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26003 22.09L6.28003 25.52L25.88 36.72L26.22 31.84L9.26003 22.09Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6777 43.7178C37.2892 42.2101 37.3378 37.4052 34.7862 32.9857C32.2347 28.5663 28.0492 26.2059 25.4377 27.7137C22.8262 29.2214 22.7777 34.0263 25.3292 38.4457C27.8808 42.8652 32.0662 45.2256 34.6777 43.7178Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3890_386542",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 20,
    width: 31,
    height: 25
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.14 28.12C27.01 26.35 24.36 27.38 23.65 30.36L12.95 24.2C13.17 23.47 13.7 22.23 14.94 21.39V20.82L13.83 20.42L9.72004 22.34L9.27004 22.08L6.29004 25.51L24.11 35.69C25.16 38.81 27.39 41.81 30 43.28C33.65 45.34 36.64 43.61 36.68 39.42C36.72 35.23 33.8 30.16 30.15 28.1L30.14 28.12Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3890_386542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.46 29.27L13.92 20.81L9.90002 23.13L24.43 31.59L28.46 29.27Z",
    fill: "#BCBCBC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3890_386542",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 27,
    width: 14,
    height: 18
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6777 43.7179C37.2892 42.2101 37.3378 37.4052 34.7862 32.9858C32.2347 28.5664 28.0492 26.206 25.4377 27.7137C22.8262 29.2215 22.7777 34.0264 25.3292 38.4458C27.8808 42.8652 32.0662 45.2256 34.6777 43.7179Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3890_386542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.16 37.4C38.16 33.87 35.68 29.57 32.62 27.81C31.07 26.92 29.68 26.84 28.67 27.44L26.02 28.97L27.08 30.87C27.08 30.87 27.08 30.96 27.08 31C27.08 34.48 29.49 38.69 32.48 40.51L33.67 42.64L36.51 41C37.53 40.43 38.15 39.18 38.15 37.4H38.16Z",
    fill: "url(#paint3_linear_3890_386542)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6501 30.36L28.9501 27.28L27.0801 26.17L22.0601 28.45L23.6501 30.36Z",
    fill: "#DCDCDC"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.99 29.33C27.22 27.73 24.91 28.75 24.49 31.57L23.54 31.02L9.90002 23.13V26.85L24.93 35.54C25.82 38.25 27.75 40.89 29.98 42.2C33.05 43.97 35.55 42.52 35.55 38.98C35.55 35.44 33.05 31.1 29.98 29.33H29.99Z",
    fill: "#A0A0A0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3890_386542",
    x1: 68.53,
    y1: 74.36,
    x2: 14.26,
    y2: 42.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#565656",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#171717",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3890_386542",
    x1: 21.38,
    y1: 9.78999,
    x2: 64.38,
    y2: 60.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3890_386542",
    x1: 12.61,
    y1: 38,
    x2: 62.95,
    y2: 38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEBEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3890_386542",
    x1: 28.72,
    y1: 39.78,
    x2: 34.88,
    y2: 29.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B1B0B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#A5A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#9E9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#9D9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceendpointlarge);
export default __webpack_public_path__ + "static/media/service endpoint large.9b8a39f1eb3387ed9b21439bd6460b12.svg";
export { ForwardRef as ReactComponent };